import React from 'react';
import { Helmet } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import SinglePage from './pages/SinglePage';

const structuredData = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "GDWD SIA",
  "url": "https://gdwd.co.uk",
  "email": "info@gdwd.co.uk",
  "description": "GDWD SIA (Reg. Nr. 40103981811) - Professional web development, web design, mobile apps, and IT services.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Liepdārzi 15",
    "addressLocality": "Baldones nov.",
    "postalCode": "LV-2125",
    "addressCountry": "LV"
  },
  "sameAs": [
    "https://github.com/guntarsdikis",
    "https://www.linkedin.com/in/guntarsdikis"
  ]
};

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>GDWD - Web Development &amp; IT Services</title>
        <meta name="description" content="GDWD SIA - Professional web development, web design, mobile apps, and IT services. Based in Latvia, serving clients worldwide." />
        <link rel="canonical" href="https://gdwd.co.uk" />

        <meta property="og:title" content="GDWD - Web Development & IT Services" />
        <meta property="og:description" content="GDWD SIA - Professional web development, web design, mobile apps, and IT services. Based in Latvia, serving clients worldwide." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://gdwd.co.uk" />
        <meta property="og:image" content="https://gdwd.co.uk/images/og-image.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="GDWD - Web Development & IT Services" />
        <meta name="twitter:description" content="GDWD SIA - Professional web development, web design, mobile apps, and IT services. Based in Latvia, serving clients worldwide." />

        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <Header />
      <main id="main">
        <SinglePage />
      </main>
      <Footer />
    </div>
  );
}

export default App;
